import { findEnterpriseList , examineEnterprise } from '@/service/api';
import {IEnterpriseState,IEnterpriseList} from '@/typings/authAudit';
import { Module } from 'vuex';
import { IGlobalState } from '..';
import * as Types from '../action-types';


const state: IEnterpriseState = {
    keyWord:'',
    page:1,
    pageCount:0,
    totalRows:0,
    examineResult:false,
    enterpriseList:[]
};

const enterprise: Module<IEnterpriseState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_ENTERPRISELIST](state, payload: IEnterpriseList[]) {
            state.enterpriseList = payload;
        },
        [Types.SET_ENTERPPAGECOUNT](state, data) {
            state.pageCount = data;
        },
        [Types.SET_ENTERPTOTALROWS](state,data) {
            state.totalRows = data;
        },
        [Types.SET_EXAMINEENTERRESULT](state,data) {
            state.examineResult = data;
        }
    },
    actions: {
        // 获取厂商列表
        async [Types.SET_ENTERPRISELIST]({ commit },params) {
            let result = await findEnterpriseList(params);
            let enterpriseList: IEnterpriseList[] = result.data.rows;
            let pageCount = result.data.page_count;
            let totalRows = result.data.total_rows;
            commit(Types.SET_ENTERPRISELIST, enterpriseList);
            commit(Types.SET_ENTERPPAGECOUNT, pageCount);
            commit(Types.SET_ENTERPTOTALROWS, totalRows);
        },
        // 审核厂商
        async [Types.SET_AUDITENTERPRISE]({ commit },params) {
            let result = await examineEnterprise(params);
            let examineResult=result.code==1;
            commit(Types.SET_EXAMINEENTERRESULT, examineResult);
        }
    }
};
export default enterprise;